/**
 * Copyright (c) ActiveWidgets SARL. All Rights Reserved.
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import {SvelteComponent} from './framework.js';
import {Button as _Button} from '@activewidgets/ui';

export const Button = SvelteComponent(_Button);
